import { memo } from 'react'
import { FormattedMessage } from 'react-intl'
import { Tooltip, styled } from '@mui/material'
import { CardFooterItemProps } from './CardFooterInterfaces'
import { ICON_SIZE_MEDIUM, ICON_SIZE_LARGE } from '@carto/meridian-ds/theme'

const Icon = styled('div', {
  shouldForwardProp: (prop) => prop !== 'hasCustomStyles'
})<{
  hasCustomStyles?: boolean
}>(({ hasCustomStyles, theme }) => ({
  ...(!hasCustomStyles && {
    display: 'flex',
    marginRight: theme.spacing(1),
    color: 'inherit',

    '& svg': {
      fontSize: ICON_SIZE_MEDIUM,
      width: ICON_SIZE_MEDIUM,
      height: ICON_SIZE_MEDIUM,

      '& path': {
        fill: 'currentColor'
      }
    },
    '.MuiAvatar-root': {
      width: ICON_SIZE_LARGE,
      height: ICON_SIZE_LARGE
    }
  })
}))

function CardFooterItemIcon({
  tooltip,
  tooltipLabelId,
  tooltipLabelValue,
  icon,
  showTooltip,
  iconClassName
}: CardFooterItemProps & { showTooltip?: boolean }) {
  const hasCustomStyles = iconClassName != undefined

  if (!icon) return null

  return tooltip && (tooltipLabelId || tooltipLabelValue) ? (
    <Tooltip
      open={showTooltip}
      title={tooltipLabelId ? <FormattedMessage id={tooltipLabelId} /> : tooltipLabelValue || false}
    >
      <Icon hasCustomStyles={hasCustomStyles} className={iconClassName}>
        {icon}
      </Icon>
    </Tooltip>
  ) : (
    <Icon hasCustomStyles={hasCustomStyles} className={iconClassName}>
      {icon}
    </Icon>
  )
}

export default memo(CardFooterItemIcon)
